goog.provide("shadow.js.shim.module$$tiptap$extension_link");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_link");
shadow.js.shim.module$$tiptap$extension_link = shadow.js.nativeProvides["@tiptap/extension-link"] = shadow$bridge("@tiptap/extension-link");
module$shadow_js_shim_module$$tiptap$extension_link.default = shadow.js.shim.module$$tiptap$extension_link;
